import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { z } from "zod";
//#region src/central/v3/content-destinations/patch.ts
var patch_exports = /* @__PURE__ */ __exportAll({ RequestSchema: () => RequestSchema });
var RequestSchema = z.object({
	description: z.string().optional(),
	title: z.string()
});
//#endregion
export { patch_exports };

//# sourceMappingURL=patch.js.map